
import { Component, Vue } from 'vue-property-decorator'
import { ICumulativeRainfallService } from '@/services/cumulative-rainfall/ICumulativeRainfallService'
import { getEnv } from '@/utils/env'

@Component({})
export default class GradientLegendHeaderRainfallDropdown extends Vue {
  private cumulativeRainfallService!: ICumulativeRainfallService
  private cumulativeRainfalls: ReturnType<ICumulativeRainfallService['getCumulativeRainfall']> = new Map()

  REAL_TIME_VALUE = 0

  defaultRainfall: number = (getEnv('VUE_APP_DEFAULT_RAINFALL') as number) || 5

  created(): void {
    this.cumulativeRainfallService = this.$services.get('cumulative-rainfall')
    this.cumulativeRainfalls = this.cumulativeRainfallService.getCumulativeRainfall()
  }

  beforeDestroy(): void {
    this.cumulativeRainfallService.selectCumulativeRainfallByTime(undefined)
  }

  onCumulativeRainfallSelect(cumulativeRainfallSelection: number): void {
    if (cumulativeRainfallSelection === this.REAL_TIME_VALUE) {
      this.cumulativeRainfallService.selectCumulativeRainfallByTime(undefined)
    } else {
      this.cumulativeRainfallService.selectCumulativeRainfallByTime(cumulativeRainfallSelection)
    }
  }

  intervalFormatter(interval: number): string {
    if (interval < 0) {
      throw new Error('Interval must be non-negative')
    }

    const hours = Math.floor(interval / 60)
    const minutes = interval % 60

    const parts: string[] = []

    if (hours > 0) {
      parts.push(`${hours} hr${hours > 1 ? 's' : ''}`)
    }
    if (minutes > 0) {
      parts.push(`${minutes} min${minutes > 1 ? 's' : ''}`)
    }

    // If both are zero
    if (parts.length === 0) {
      return '0 min'
    }

    return parts.join(' ')
  }
}
